import { Component, OnInit } from '@angular/core';
import {UtilService} from '../../services/utilService/util.service';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {SuperAdminService} from '../../services/apiCalls/superAdminService/super-admin.service';
import {IResponse} from '../../interfaces/iresponse';
import {UserService} from '../../services/apiCalls/userService/user.service';
import { environment as ENV } from '../../../environments/environment';
@Component({
  selector: 'app-manage-beneficiaries',
  templateUrl: './manage-beneficiaries.component.html',
  styleUrls: ['./manage-beneficiaries.component.css']
})
export class ManageBeneficiariesComponent implements OnInit {
  breadCrumb: any;
  showData = true;
  public beneficiaries: any[] = [];
  allStates: any[] = [];
  allLGA: any[] = [];
  allBanks: any[] = [];
  allCountry: any[] = [{name: 'Nigerian'}, {name: 'Congo DRC'}];
  loadingData = false;
  stateSelected = false;
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  loaders = {
    saving: false
  };
  modal = {
    title: 'Create Beneficiary',
    btnText: 'SAVE'
  };
  activeBeneficiary = null;
  beneficiary =  {
    first_name: null,
    last_name: null,
    email: null,
    phone_no: null,
    bank_id: null,
    account_name: null,
    account_no: null
  };
  constructor(private utilService: UtilService,
              private bootstrapNotify: BootstrapNotifyService,
              private userService: UserService,
              private superAdminService: SuperAdminService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Manage Beneficiary',
      parent: 'Settings',
      subLink: null
    };
    this.getStates();
    this.getBeneficiary();
    this.getBanks();
  }

  getBeneficiary() {
    this.showData = false;

    this.loadingData = true;
    this.beneficiaries = [];
    this.superAdminService.getBeneficiaries()
      .subscribe((res: IResponse) => {
        this.beneficiaries = res.data;
        this.utilService.startDatatable('all-beneficiaries');
        this.loadingData = false;
        this.showData = true;
      }, error => {
        this.utilService.startDatatable('all-beneficiaries');
        this.loadingData = false;
        this.showData = true;
      });
  }


  openDialog(id) {
    this.modal = {
      title: 'Create Beneficiary',
      btnText: 'SAVE'
    };
    this.activeBeneficiary = null;
    this.resetForm();
    this.utilService.openModal(id);
  }

  public deleteBeneficiary(beneficiary) {
    this.utilService.confirmAction(() => {
      this.superAdminService.deleteBeneficiary(beneficiary.id)
        .subscribe((res: IResponse) => {
          this.getBeneficiary();
        }, error => {

        });
    });
  }
  public triggerEdit(beneficiary) {
    this.activeBeneficiary = JSON.parse(JSON.stringify(beneficiary));
    this.resetForm();
    this.utilService.openModal('createBeneficiary');
    this.beneficiary = this.activeBeneficiary;
    this.modal = {
      title: 'Update Beneficiary',
      btnText: 'UPDATE'
    };
  }

  public resetForm() {
    this.beneficiary =  {
      first_name: null,
      last_name: null,
      email: null,
      phone_no: null,
      bank_id: null,
      account_name: null,
      account_no: null
    };
  }
  public createBeneficiary() {
    this.loaders.saving = true;
    this.checkError(this.beneficiary, () => {
      if (this.activeBeneficiary) {
        this.updateBeneficiary();
      } else {
        this.superAdminService.createBeneficiary(this.beneficiary).subscribe((response: IResponse) => {
          this.loaders.saving = false;
          this.resetForm();
          this.getBeneficiary();
          this.utilService.closeModal('createBeneficiary');
          this.bootstrapNotify.success(response.message || 'Beneficiary added successfully!', 'right');
        }, error => {
          this.bootstrapNotify.error(error.error.message || 'Unable to create beneficiary!', 'right');
          this.loaders.saving = false;
          console.info('Error => ', error);
        });
      }
    }, []);
  }
  public checkError(data, cb, omit= []) {
    const keys = Object.keys(data);
    const resolvedKeys = keys.filter(d => !omit.includes(d));
    for (const key of resolvedKeys) {
      if (!data[key]) {
          this.loaders.saving = false;
          return this.bootstrapNotify.info(`${key.toString().toUpperCase().split('_').join(' ')} is Required`);
        }
    }
    cb();
  }
  public updateBeneficiary() {
    this.superAdminService.updateBeneficiary(this.beneficiary, this.activeBeneficiary.id).subscribe((response: IResponse) => {
      this.loaders.saving = false;
      this.resetForm();
      this.getBeneficiary();
      this.utilService.closeModal('createBeneficiary');
      this.bootstrapNotify.success(response.message || 'Beneficiary updated successfully!', 'right');
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update beneficiary!', 'right');
      this.loaders.saving = false;
    });
  }

  public getStates() {
    this.userService.getAllState().subscribe(res => {
      this.allStates = res.data;
    }, error => {
    });
  }
  public filterLGA(e) {
    this.stateSelected = true;
    this.allLGA = e.lgas;
  }

  getBanks() {
    this.superAdminService.getBanks()
      .subscribe((res: IResponse) => {
        this.allBanks = res.data;
      }, error => {
      });
  }
}
